import React, { CSSProperties } from 'react';

import DropDown from 'components/DropDown/DropDown';
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down.svg';

import './ClassDropDown.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  styleDropDown?: CSSProperties;
  value?: string | number;
  icon?: string;
  boxStyle?: CSSProperties;
  spanStyle?: CSSProperties;
  dropdownButtonStyle?: CSSProperties;
  containerStyle?: CSSProperties;
}

const CardDropDown: React.FC<Props> = ({
  style,
  children,
  spanStyle,
  dropdownButtonStyle,
  containerStyle,
  styleDropDown,
  value,
}) => {
  const Icon = (
    <div className="iconContainer" style={containerStyle}>
      <span style={spanStyle}>{value}</span>
      <ArrowIcon className="arrow" />
    </div>
  );

  return (
    <div className="class-dropdown" style={{ height: '48px', ...style }}>
      <DropDown
        icon={Icon}
        style={dropdownButtonStyle}
        boxStyle={{ left: '0px', ...styleDropDown }}
      >
        {children}
      </DropDown>
    </div>
  );
};

export default CardDropDown;
